import { AxiosResponse } from 'axios'
import axiosApi from '../api/axios-api'

export default {
	companyReportNotification(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/notification`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportFind(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `find`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportSave(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `save`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportView(id: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `view/` + id, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportCheck(id: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `check/` + id, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportUpdate(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `update`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportSubmit(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `submit`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportCheckError(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `checkerror`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportReject(request: any, sheetType: any, id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `reject/` + id, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportUnfinalise(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `unfinalise`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportDelete(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `delete`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportImport(request: any, id: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/companyreport/` + sheetType + `/` + `import/` + id, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportExport(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/companyreport/` + sheetType + `/` + `export`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportLoad(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `load`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportReset(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`companyreport/` + sheetType + `/` + `reset`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportRetranslate(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`companyreport/` + sheetType + `/` + `retranslate`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportCalculateForeign(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`companyreport/` + sheetType + `/` + `calculate/foreign`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportResetAll(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`companyreport/` + sheetType + `/` + `reset/all`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportUpdateId(request: any, sheetType: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + templateIndex + `/` + `id/update`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportUpdateIsNearestThousand(request: any, sheetType: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + templateIndex + `/` + `isnearestthousand/update`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportCheckUnsaved(id: any, sheetType: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + templateIndex + `/` + `checkunsaved/` + id, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
    },
    companyReportListByPreviousCompanyReport(request: any, sheetType: any) {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + `list/previous`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
	},
	companyReportListByConsoGroupNameDate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/list/consogroup`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
    companyReportLastAccess(request: any, sheetType: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreport/` + sheetType + `/` + templateIndex + `/` + `lastaccess`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	companyReportReportExport(request: any, sheetType: any, id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/companyreport/` + sheetType + `/` + id + `/report/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    companyReportEliminationExport(request: any, sheetType: any, id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/companyreport/` + sheetType + `/` + id + `/elimination/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	companyReportCheckLoaded(id: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/companyreport/` + sheetType + `/` + `checkloaded/` + id, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
    companyReportNearestThousand(request: any): Promise<AxiosResponse<any>> {
        return new Promise((resolve, reject) => {
            axiosApi.axiosPost('/companyreport/nearestthousand', request)
            .then(function(response) {
                resolve(response);
            })
            .catch(function(error) {
                reject(error);
            })
        })
    },
	companyReportImportForeign(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/companyreport/` + sheetType + `/` + `importforeign`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportExportForeign(request: any, sheetType: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/companyreport/` + sheetType + `/` + `exportforeign`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
}
